const nonBreakingSpace = "\xa0";

export const toCurrency = amount => {
    return `P${nonBreakingSpace}${amount}`;
};

export const toData = amount => {
    return `MB${nonBreakingSpace}${amount}`;
};

export const emptyString = "";
